<div class="col-span-6 list-procedures">
  <div class="px-6 py-5 border-b border-border-100">
    <h2 class="text-lg font-semibold">Procedimentos</h2>
  </div>
  <form [formGroup]="formInfo">
    <app-alert
      message="Ao marcar essa opção, você deve selecionar um cupom já adquirido pelo beneficiário."
      title="O beneficiário já possui procedimentos comprados"
      class="mx-6 my-8"
    >
      <ng-template #icon>
        <app-toggle-switch formControlName="beneficiaryHasProcedures" />
      </ng-template>
    </app-alert>
  </form>

  <app-divider class="mb-3 px-6" />

  @if (!formInfo.value.beneficiaryHasProcedures) {
    <div class="px-6 pt-5 pb-8">
      <form [formGroup]="formCouponProcedure">
        <app-input-icon
          position="left"
          placeholder="Buscar procedimento"
          fullWidth
          class="mb-8"
          formControlName="physicianProceduresSearch"
        />
      </form>

      @for (
        procedure of (procedureList$ | async) ?? [];
        track idx;
        let idx = $index
      ) {
        <app-physician-procedure-item
          [procedure]="procedure"
          [toogleSelectProcedure]="toogleSelectProcedure"
          [isSelected]="
            selectionService.isSelected(procedure.procedureId.toString())
              | async
          "
        />
        <app-divider />
      }

      @let pageSize = (paginationService.getPageSize() | async) ?? 10;
      @let currentPage = (paginationService.getCurrentPage() | async) ?? 1;
      <app-paginator
        [totalRecords]="(paginationService.getTotalRecords() | async) ?? 0"
        [rows]="pageSize"
        [first]="(currentPage - 1) * pageSize"
        (pageChange)="onPageChange($event)"
      />
    </div>
  } @else {
    <div class="px-6 pt-5 pb-8 w-full">
      @if (userCoupons && userCoupons.length > 0) {
        <div class="mb-4">
          <p class="text-sm text-text-600 mb-4">
            Selecione um dos cupons adquiridos pelo beneficiário:
          </p>
        </div>

        @for (coupon of userCoupons; track coupon.id) {
          <app-user-coupon-item
            [coupon]="coupon"
            [toggleSelectCoupon]="toggleSelectCoupon"
            [isSelected]="couponSelectionService.isSelected(coupon.id) | async"
          />
          <app-divider />
        }
      } @else {
        <div class="text-center py-8">
          <h3 class="text-lg font-medium text-text-900 mb-2">
            Nenhum cupom encontrado
          </h3>
          <p class="text-text-500">
            O beneficiário não possui cupons de procedimentos adquiridos.
          </p>
        </div>
      }
    </div>
  }
</div>
<div class="col-span-6">
  <section class="flex flex-col mb-4 text-sm list-selected-procedures">
    <div class="px-6 py-5 border-b border-border-100">
      <h2 class="text-lg font-semibold">Agendamento</h2>
    </div>

    <form [formGroup]="formAppointment" class="py-8">
      <app-calendar formControlName="appointmentDateTime"></app-calendar>
    </form>
  </section>

  <section
    class="flex flex-col gap-2 px-16 py-12 text-sm list-selected-procedures"
  >
    @let proceduresPrices = getProceduresPrice() | async;
    <div class="flex justify-between">
      <p>Procedimentos</p>
      <p>
        {{ convertToBrazilianCurrency(proceduresPrices?.proceduresTotal ?? 0) }}
      </p>
    </div>
    <div class="flex justify-between mb-2">
      <p>Serviço</p>
      <p>
        {{ convertToBrazilianCurrency(proceduresPrices?.serviceTax ?? 0) }}
      </p>
    </div>
    <div class="flex justify-between">
      <p>Total de descontos</p>
      <div>
        <span
          class="px-2 py-1 mr-2 text-xs font-medium rounded text-text-50 bg-background-700"
        >
          {{
            (
              (proceduresPrices!.discountTotal /
                proceduresPrices!.proceduresTotal) *
                100 || 0
            ).toFixed(2)
          }}%
        </span>
        <p class="inline text-sm font-bold text-red-500">
          -{{
            convertToBrazilianCurrency(
              proceduresPrices?.discountTotalWithTax ?? 0
            )
          }}
        </p>
      </div>
    </div>
    <app-divider />
    <div class="flex justify-between mt-2 mb-12 text-lg font-bold">
      <p>Total</p>
      <p>
        {{
          convertToBrazilianCurrency(
            proceduresPrices?.proceduresPriceWithTaxTotal ?? 0
          )
        }}
      </p>
    </div>
    <div class="grid grid-cols-12 gap-4">
      <app-button
        buttonType="secondary"
        label="Voltar"
        class="col-span-6"
        fullSize
        (handleClick)="goBack()"
      />
      <app-button
        label="Avançar"
        class="col-span-6"
        fullSize
        (handleClick)="goNext()"
        [disabled]="
          formAppointment.invalid ||
          (formInfo.value.beneficiaryHasProcedures &&
            (hasSelectedCoupons$() | async) === false) ||
          (!formInfo.value.beneficiaryHasProcedures &&
            (hasSelectedProcedures$() | async) === false)
        "
      />
    </div>
  </section>
</div>
